const REPORT_LIST_KEYS = [
  "group_by",
  "metric",
  "app_id_list",
  "placement_id_list",
  "adsource_id_list",
  "network_id_list",
  "scenario_id_list",
  "traffic_group_id_list",
  "channel_id_list",
  "sdk_version_list",
  "app_version_list",
  "area_id_list",
];

const FULL_REPORT_FILTER_BAR_OPTIONS = {
  network: [
    { value: "admob", label: "AdMob" },
    { value: "pangle", label: "Pangle" },
    { value: "mintegral", label: "Mintegral" },
    { value: "unity_ads", label: "Unity Ads" },
    { value: "ironsource", label: "ironSource" },
  ],
  adType: [
    { value: "rewarded", label: "激励视频" },
    { value: "interstitial", label: "插屏" },
    { value: "banner", label: "Banner" },
    { value: "native", label: "原生" },
    { value: "splash", label: "开屏" },
  ],
};

const FULL_REPORT_METRIC_GROUPS = [
  {
    key: "user_behavior",
    label: "用户行为",
    metrics: ["dau", "deu", "arpu", "arpdeu", "new_users"],
  },
  {
    key: "revenue",
    label: "收益数据",
    metrics: ["cy_estimate_revenue", "estimated_revenue_ecpm", "revenue", "ecpm"],
  },
  {
    key: "bidding",
    label: "竞价数据",
    metrics: ["revenue_gap"],
  },
  {
    key: "request_display",
    label: "广告请求展示",
    metrics: ["request", "request_fill_rate", "impression", "impression_rate", "click", "click_rate", "loads", "load_fill_rate"],
  },
  {
    key: "ready",
    label: "广告Ready数据",
    metrics: ["ecpm_api"],
  },
  {
    key: "other",
    label: "其他",
    metrics: [],
  },
];

const FULL_REPORT_DIMENSION_OPTIONS = [
  { value: "date", label: "日期" },
  { value: "app", label: "应用" },
  { value: "placement", label: "广告位" },
  { value: "adsource", label: "广告源" },
  { value: "network", label: "广告平台" },
  { value: "scenario", label: "广告场景" },
  { value: "traffic_group", label: "流量分组" },
  { value: "channel", label: "渠道" },
  { value: "sdk_version", label: "SDK版本" },
  { value: "app_version", label: "应用版本" },
  { value: "area", label: "地区" },
];

const FULL_REPORT_METRIC_OPTIONS = [
  { value: "all", label: "全部指标" },
  { value: "cy_estimate_revenue", label: "预计收益" },
  { value: "estimated_revenue_arpdeu", label: "预估ARPDEU" },
  { value: "estimated_revenue_ecpm", label: "预计eCPM" },
  { value: "request", label: "广告请求" },
  { value: "request_fill_rate", label: "广告填充率" },
  { value: "impression", label: "展示" },
  { value: "impression_rate", label: "展示率" },
  { value: "click", label: "点击" },
  { value: "click_rate", label: "点击率" },
  { value: "loads", label: "流量请求" },
  { value: "load_fill_rate", label: "流量填充率" },
  { value: "dau", label: "DAU" },
  { value: "deu", label: "DEU" },
  { value: "arpu", label: "ARPU" },
  { value: "arpdeu", label: "ARPDEU" },
  { value: "new_users", label: "新用户" },
  { value: "ecpm", label: "eCPM" },
  { value: "ecpm_api", label: "eCPM API" },
  { value: "revenue", label: "收益" },
  { value: "revenue_gap", label: "收益差" },
];

const HOURLY_FIXED_METRIC_OPTIONS = [
  { value: "cy_estimate_revenue", label: "预计收益" },
  { value: "estimated_revenue_ecpm", label: "预计eCPM" },
  { value: "loads", label: "流量请求" },
  { value: "load_fill_rate", label: "流量填充率" },
  { value: "request", label: "广告请求" },
  { value: "request_fill_rate", label: "广告填充率" },
  { value: "impression", label: "展示" },
  { value: "impression_rate", label: "展示率" },
  { value: "click", label: "点击" },
  { value: "click_rate", label: "点击率" },
];

const LABEL_MAP = {
  date: "日期",
  hour: "小时",
  app: "应用",
  app_id: "APP ID",
  app_name: "应用名称",
  placement: "广告位",
  placement_id: "广告位ID",
  placement_name: "广告位名称",
  adsource: "广告源",
  adsource_id: "广告源ID",
  adsource_name: "广告源名称",
  network: "广告平台",
  network_id: "广告平台ID",
  network_name: "广告平台名称",
  scenario: "广告场景",
  scenario_id: "广告场景ID",
  traffic_group: "流量分组",
  traffic_group_id: "流量分组ID",
  channel: "渠道",
  channel_id: "渠道ID",
  sdk_version: "SDK版本",
  app_version: "应用版本",
  area: "地区",
  area_id: "地区ID",
  area_name: "地区名称",
  request: "广告请求",
  request_api: "请求 API",
  request_fill_rate: "广告填充率",
  fillrate: "请求填充率",
  fillrate_api: "填充率 API",
  ready_rate: "准备率",
  impression: "展示",
  impression_api: "展示 API",
  impression_rate: "展示率",
  impression_gap: "展示差",
  click: "点击",
  click_api: "点击 API",
  click_rate: "点击率",
  click_gap: "点击差",
  ctr: "CTR",
  ctr_api: "CTR API",
  ecpm: "eCPM",
  ecpm_api: "eCPM API",
  ecpm_gap: "eCPM差",
  ecpc: "eCPC",
  ecpr: "eCPR",
  revenue: "收益API",
  cy_estimate_revenue: "预估收益",
  estimated_revenue_arpdeu: "预估ARPDEU",
  revenue_gap: "收益差",
  estimated_revenue_ecpm: "预计eCPM",
  dau: "DAU",
  deu: "DEU",
  arpu: "ARPU",
  arpdeu: "ARPDEU",
  cy_arpu: "次日ARPU",
  engaged_rate: "活跃率",
  imp_dau: "展示DAU",
  imp_deu: "展示DEU",
  new_user_rate: "新用户率",
  dau_launch: "DAU启动数",
  estimated_revenue_arpu: "收益ARPU",
  new_users: "新用户",
  day2_retention: "次留",
  load: "加载数",
  loads: "流量请求",
  loads_filled: "已填充加载数",
  load_fill_rate: "流量填充率",
  load_fillrate: "流量填充率",
  request_filled: "已填充请求数",
  ready_request: "准备请求",
  unit_ecpc: "单位eCPC",
  unit_ecpr: "单位eCPR",
};

const FULL_DIMENSION_PRIORITY = [
  "date",
  "app",
  "app_id",
  "app_name",
  "placement",
  "placement_id",
  "placement_name",
  "adsource",
  "adsource_id",
  "adsource_name",
  "network",
  "network_id",
  "network_name",
  "scenario",
  "scenario_id",
  "traffic_group",
  "traffic_group_id",
  "channel",
  "channel_id",
  "sdk_version",
  "app_version",
  "area",
  "area_id",
  "area_name",
];

const HOURLY_DETAIL_PRIORITY = [
  "date",
  "hour",
  "app_id",
  "placement_id",
  "app_name",
  "placement_name",
  "loads",
  "load_fill_rate",
  "request",
  "request_fill_rate",
  "impression",
  "impression_rate",
  "click",
  "click_rate",
  "cy_estimate_revenue",
  "estimated_revenue_ecpm",
];

const HOURLY_SUMMARY_PRIORITY = [
  "hour",
  "loads",
  "load_fill_rate",
  "request",
  "request_fill_rate",
  "impression",
  "impression_rate",
  "click",
  "click_rate",
  "cy_estimate_revenue",
  "estimated_revenue_ecpm",
];

const RATE_HINTS = ["rate", "fillrate", "ctr", "retention"];
const CURRENCY_HINTS = ["revenue", "income", "ecpm", "ecpc", "ecpr", "arpu", "arpdeu"];

function isDateInstance(value) {
  return Object.prototype.toString.call(value) === "[object Date]" && !Number.isNaN(value.getTime());
}

function padNumber(value) {
  return String(value).padStart(2, "0");
}

function parseDateValue(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  if (isDateInstance(value)) {
    return value;
  }

  if (typeof value === "number" && Number.isFinite(value)) {
    const numericText = String(Math.trunc(value));
    if (/^\d{8}$/.test(numericText)) {
      const year = Number(numericText.slice(0, 4));
      const month = Number(numericText.slice(4, 6)) - 1;
      const day = Number(numericText.slice(6, 8));
      return new Date(year, month, day);
    }
  }

  if (typeof value === "number" && Number.isFinite(value)) {
    const timestamp = String(Math.trunc(value)).length <= 10 ? value * 1000 : value;
    const date = new Date(timestamp);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) {
      return null;
    }
    if (/^\d{8}$/.test(trimmed)) {
      const year = Number(trimmed.slice(0, 4));
      const month = Number(trimmed.slice(4, 6)) - 1;
      const day = Number(trimmed.slice(6, 8));
      return new Date(year, month, day);
    }
    if (/^\d+$/.test(trimmed)) {
      return parseDateValue(Number(trimmed));
    }
    const normalized = trimmed.replace(/-/g, "/");
    const date = new Date(normalized);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  return null;
}

export function formatDateToYYYYMMDD(value) {
  const date = parseDateValue(value);
  if (!date) {
    return "";
  }
  return [
    date.getFullYear(),
    padNumber(date.getMonth() + 1),
    padNumber(date.getDate()),
  ].join("");
}

export function formatYYYYMMDD(value) {
  const normalized = formatDateToYYYYMMDD(value);
  if (!normalized) {
    return "--";
  }
  return `${normalized.slice(0, 4)}-${normalized.slice(4, 6)}-${normalized.slice(6, 8)}`;
}

export function formatHourRange(hour) {
  if (hour === null || hour === undefined || hour === "") {
    return "--";
  }
  const hourNumber = Number(hour);
  if (!Number.isFinite(hourNumber)) {
    return String(hour);
  }
  const displayHour = padNumber(hourNumber);
  return `${displayHour}:00 - ${displayHour}:59`;
}

export function getLabelForKey(key) {
  if (LABEL_MAP[key]) {
    return LABEL_MAP[key];
  }
  return String(key || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

function toCommaSeparated(value) {
  if (Array.isArray(value)) {
    const list = value
      .map((item) => String(item || "").trim())
      .filter(Boolean);
    return list.length ? list.join(",") : "";
  }
  if (value === null || value === undefined) {
    return "";
  }
  return String(value)
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean)
    .join(",");
}

function shouldKeepBoolean(key, value) {
  if (key !== "force_refresh") {
    return true;
  }
  return value === true || String(value).toLowerCase() === "true";
}

export function normalizeReportParams(rawParams = {}, options = {}) {
  const {
    dateKeys = [],
    listKeys = REPORT_LIST_KEYS,
  } = options;
  const params = { ...rawParams };

  if (params.limit === undefined && params.pageSize !== undefined) {
    params.limit = params.pageSize;
  }
  if (params.start === undefined && params.page !== undefined && params.pageSize !== undefined) {
    params.start = Math.max(Number(params.page) - 1, 0) * Number(params.pageSize);
  }

  delete params.page;
  delete params.pageSize;

  dateKeys.forEach((key) => {
    if (key in params) {
      params[key] = formatDateToYYYYMMDD(params[key]);
    }
  });

  listKeys.forEach((key) => {
    if (key in params) {
      params[key] = toCommaSeparated(params[key]);
    }
  });

  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value === null || value === undefined) {
      delete params[key];
      return;
    }
    if (typeof value === "boolean") {
      if (!shouldKeepBoolean(key, value)) {
        delete params[key];
        return;
      }
      params[key] = "true";
      return;
    }
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed) {
        delete params[key];
        return;
      }
      params[key] = trimmed;
      return;
    }
    if (Array.isArray(value) && value.length === 0) {
      delete params[key];
    }
  });

  return params;
}

function isNumericLike(value) {
  if (value === null || value === undefined || value === "") {
    return false;
  }
  if (typeof value === "number") {
    return Number.isFinite(value);
  }
  if (typeof value === "string") {
    const normalized = value.trim();
    return normalized !== "" && !Number.isNaN(Number(normalized));
  }
  return false;
}

function toNumber(value) {
  if (!isNumericLike(value)) {
    return null;
  }
  return Number(value);
}

function uniqueKeys(records = []) {
  const keys = [];
  const visited = new Set();
  records.forEach((record) => {
    Object.keys(record || {}).forEach((key) => {
      if (!visited.has(key)) {
        visited.add(key);
        keys.push(key);
      }
    });
  });
  return keys;
}

function isDimensionKey(key, selectedDimensions = []) {
  return FULL_DIMENSION_PRIORITY.includes(key) ||
    selectedDimensions.includes(key) ||
    /(_id|_name)$/.test(key);
}

function buildColumnConfig(key) {
  return {
    key,
    label: getLabelForKey(key),
    minWidth: key.length > 14 ? 180 : 140,
  };
}

export function buildFullReportColumns(records = [], selectedDimensions = []) {
  const keys = uniqueKeys(records);
  const seen = new Set();
  const dimensionKeys = [];
  const metricKeys = [];

  [...FULL_DIMENSION_PRIORITY, ...selectedDimensions, ...keys].forEach((key) => {
    if (seen.has(key) || !keys.includes(key) || !isDimensionKey(key, selectedDimensions)) {
      return;
    }
    seen.add(key);
    dimensionKeys.push(key);
  });

  keys.forEach((key) => {
    if (!seen.has(key)) {
      metricKeys.push(key);
    }
  });

  return [...dimensionKeys, ...metricKeys].map(buildColumnConfig);
}

export function buildFullReportColumnsWithMetricOrder(
  records = [],
  selectedDimensions = [],
  visibleMetricKeys = []
) {
  const baseColumns = buildFullReportColumns(records, selectedDimensions);
  if (!Array.isArray(visibleMetricKeys) || !visibleMetricKeys.length) {
    return baseColumns;
  }

  const dimensionColumns = baseColumns.filter((column) =>
    isDimensionKey(column.key, selectedDimensions)
  );
  const metricColumns = baseColumns.filter(
    (column) => !isDimensionKey(column.key, selectedDimensions)
  );
  const metricMap = metricColumns.reduce((result, column) => {
    result[column.key] = column;
    return result;
  }, {});

  const orderedMetricColumns = visibleMetricKeys
    .map((key) => metricMap[key])
    .filter(Boolean);

  return [...dimensionColumns, ...orderedMetricColumns];
}

export function buildHourlyDetailColumns(records = []) {
  const keys = uniqueKeys(records);
  const seen = new Set();
  const ordered = [];

  [...HOURLY_DETAIL_PRIORITY, ...keys].forEach((key) => {
    if (!keys.includes(key) || seen.has(key)) {
      return;
    }
    seen.add(key);
    ordered.push(key);
  });

  return ordered.map(buildColumnConfig);
}

export function buildHourlySummaryColumns(records = []) {
  const keys = uniqueKeys(records);
  const seen = new Set();
  const ordered = [];

  [...HOURLY_SUMMARY_PRIORITY, ...keys].forEach((key) => {
    if (!keys.includes(key) || seen.has(key)) {
      return;
    }
    seen.add(key);
    ordered.push(key);
  });

  return ordered.map(buildColumnConfig);
}

export function isRateKey(key = "") {
  return RATE_HINTS.some((item) => key.includes(item));
}

export function isCurrencyKey(key = "") {
  return CURRENCY_HINTS.some((item) => key.includes(item));
}

export function formatReportValue(key, value, meta = {}) {
  if (value === null || value === undefined || value === "") {
    return "--";
  }

  if (key === "date") {
    return formatYYYYMMDD(value);
  }

  if (key === "hour") {
    return formatHourRange(value);
  }

  if (!isNumericLike(value)) {
    return String(value);
  }

  const numberValue = Number(value);
  if (isRateKey(key)) {
    const percentageValue = Math.abs(numberValue) <= 1 ? numberValue * 100 : numberValue;
    return `${percentageValue.toFixed(2)}%`;
  }

  if (isCurrencyKey(key)) {
    const formattedValue = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 4,
    }).format(Math.abs(numberValue));
    return numberValue < 0 ? `-￥${formattedValue}` : `￥${formattedValue}`;
  }

  if (Number.isInteger(numberValue)) {
    return new Intl.NumberFormat("en-US").format(numberValue);
  }

  return Number(numberValue.toFixed(4)).toString();
}

function buildCsvCell(value) {
  const normalized = String(value === null || value === undefined ? "" : value);
  return `"${normalized.replace(/"/g, '""')}"`;
}

export function downloadCsv(filename, columns = [], rows = [], meta = {}) {
  const header = columns.map((column) => buildCsvCell(column.label)).join(",");
  const body = rows
    .map((row) =>
      columns
        .map((column) => buildCsvCell(formatReportValue(column.key, row[column.key], meta)))
        .join(",")
    )
    .join("\r\n");
  const csvContent = `\uFEFF${header}\r\n${body}`;
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
}

export function sortHourlyRows(records = []) {
  return [...records].sort((left, right) => {
    const leftDate = Number(left.date || 0);
    const rightDate = Number(right.date || 0);
    if (leftDate !== rightDate) {
      return rightDate - leftDate;
    }
    return Number(right.hour || 0) - Number(left.hour || 0);
  });
}

function getExtraNumericKeys(records = [], excludedKeys = []) {
  const excludeSet = new Set(excludedKeys);
  return uniqueKeys(records).filter((key) => {
    if (excludeSet.has(key)) {
      return false;
    }
    return records.some((record) => isNumericLike(record[key]));
  });
}

export function buildHourlyMetricOptions(records = []) {
  const baseKeys = HOURLY_FIXED_METRIC_OPTIONS.map((item) => item.value);
  const extraKeys = getExtraNumericKeys(records, ["date", "hour", "app_id", "placement_id"]);
  const merged = [...baseKeys];

  extraKeys.forEach((key) => {
    if (!merged.includes(key)) {
      merged.push(key);
    }
  });

  return merged.map((key) => ({
    value: key,
    label: getLabelForKey(key),
  }));
}

export function buildHourlySummaryRows(records = []) {
  const numericKeys = getExtraNumericKeys(records, ["date", "hour"]);
  const grouped = new Map();

  records.forEach((record) => {
    const hour = Number(record.hour);
    if (!Number.isFinite(hour)) {
      return;
    }

    if (!grouped.has(hour)) {
      grouped.set(hour, {
        hour,
        __counts: {},
      });
    }

    const target = grouped.get(hour);
    numericKeys.forEach((key) => {
      const value = toNumber(record[key]);
      if (value === null) {
        return;
      }
      if (target[key] === undefined) {
        target[key] = 0;
      }
      target[key] += value;
      target.__counts[key] = (target.__counts[key] || 0) + 1;
    });
  });

  return Array.from(grouped.values())
    .map((item) => {
      const row = { hour: item.hour };
      numericKeys.forEach((key) => {
        if (item[key] === undefined) {
          row[key] = null;
          return;
        }
        if (isRateKey(key) || key.endsWith("_ecpm")) {
          row[key] = item[key] / item.__counts[key];
          return;
        }
        row[key] = item[key];
      });
      return row;
    })
    .sort((left, right) => Number(right.hour) - Number(left.hour));
}

export function buildHourlyChartData(records = [], mode = "compare", metricKey = "cy_estimate_revenue") {
  if (!records.length) {
    return {
      legend: [],
      xAxis: [],
      series: [],
    };
  }

  if (mode === "trend") {
    const sorted = [...records].sort((left, right) => {
      const leftCode = `${left.date || ""}${padNumber(left.hour || 0)}`;
      const rightCode = `${right.date || ""}${padNumber(right.hour || 0)}`;
      return leftCode.localeCompare(rightCode);
    });
    return {
      legend: [getLabelForKey(metricKey)],
      xAxis: sorted.map((item) => `${formatYYYYMMDD(item.date)} ${padNumber(item.hour)}:00`),
      series: [
        {
          name: getLabelForKey(metricKey),
          type: "line",
          smooth: true,
          data: sorted.map((item) => toNumber(item[metricKey])),
        },
      ],
    };
  }

  const hourLabels = Array.from({ length: 24 }, (_, index) => `${index}点`);
  const grouped = new Map();

  records.forEach((record) => {
    const dateKey = formatYYYYMMDD(record.date);
    if (!grouped.has(dateKey)) {
      grouped.set(dateKey, new Array(24).fill(null));
    }
    const bucket = grouped.get(dateKey);
    const hour = Number(record.hour);
    if (Number.isFinite(hour) && hour >= 0 && hour <= 23) {
      bucket[hour] = toNumber(record[metricKey]);
    }
  });

  const legend = Array.from(grouped.keys()).sort();
  const series = legend.map((dateKey) => ({
    name: dateKey,
    type: "line",
    smooth: true,
    data: grouped.get(dateKey),
  }));

  return {
    legend,
    xAxis: hourLabels,
    series,
  };
}

export function getDateRangeByShortcut(shortcut = "today") {
  const end = new Date();
  end.setHours(0, 0, 0, 0);
  const start = new Date(end);

  if (shortcut === "yesterday") {
    start.setDate(start.getDate() - 1);
    end.setDate(end.getDate() - 1);
    return [start, end];
  }

  if (shortcut === "last3") {
    start.setDate(start.getDate() - 2);
    return [start, end];
  }

  if (shortcut === "last7") {
    start.setDate(start.getDate() - 6);
    return [start, end];
  }

  if (shortcut === "last14") {
    start.setDate(start.getDate() - 13);
    return [start, end];
  }

  if (shortcut === "last30") {
    start.setDate(start.getDate() - 29);
    return [start, end];
  }

  return [start, end];
}

export function buildInclusiveDateList(startValue, endValue) {
  const start = parseDateValue(startValue);
  const end = parseDateValue(endValue);
  if (!start || !end || start.getTime() > end.getTime()) {
    return [];
  }

  const cursor = new Date(start);
  const result = [];
  while (cursor.getTime() <= end.getTime()) {
    result.push(formatDateToYYYYMMDD(cursor));
    cursor.setDate(cursor.getDate() + 1);
  }
  return result;
}

export function buildAppFilterOptions(appList = []) {
  return (appList || [])
    .filter((item) => item && item.taku_app_id)
    .map((item) => ({
      value: String(item.taku_app_id),
      label: item.app_name || item.app_code || `APP ${item.id}`,
      raw: item,
    }));
}

export function buildFullReportMetricSettingGroups(metricOptions = []) {
  const optionMap = metricOptions.reduce((result, item) => {
    result[item.value] = item;
    return result;
  }, {});
  const assigned = new Set();

  const groups = FULL_REPORT_METRIC_GROUPS.map((group) => {
    const items = group.metrics
      .map((key) => optionMap[key])
      .filter(Boolean)
      .map((item) => {
        assigned.add(item.value);
        return item;
      });
    return {
      ...group,
      items,
    };
  });

  const otherGroup = groups.find((group) => group.key === "other");
  if (otherGroup) {
    otherGroup.items = metricOptions.filter((item) => !assigned.has(item.value));
  }

  return groups.filter((group) => group.items.length > 0);
}

export function loadMetricDisplayOrder(storageKey, fallbackKeys = []) {
  if (typeof window === "undefined") {
    return [...fallbackKeys];
  }
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (!raw) {
      return [...fallbackKeys];
    }
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [...fallbackKeys];
    }
    return parsed.map((item) => String(item)).filter(Boolean);
  } catch (error) {
    return [...fallbackKeys];
  }
}

export function saveMetricDisplayOrder(storageKey, keys = []) {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.setItem(storageKey, JSON.stringify(keys));
}

export {
  FULL_REPORT_DIMENSION_OPTIONS,
  FULL_REPORT_FILTER_BAR_OPTIONS,
  FULL_REPORT_METRIC_GROUPS,
  FULL_REPORT_METRIC_OPTIONS,
  HOURLY_FIXED_METRIC_OPTIONS,
  REPORT_LIST_KEYS,
};
